export interface VersionChanges {
  version: string;
  date?: string;
  added: string[];
  changed: string[];
  fixed: string[];
  removed: string[];
}

export function parseChangelog(changelogText: string): Map<string, VersionChanges> {
  const versions = new Map<string, VersionChanges>();
  const lines = changelogText.split('\n');
  
  let currentVersion: string | null = null;
  let currentSection: 'added' | 'changed' | 'fixed' | 'removed' | null = null;
  
  for (const line of lines) {
    // Detect version: ## [4.0.1] - 2025-12-06
    const versionMatch = line.match(/^##\s+\[(\d+\.\d+\.\d+)\](?:\s+-\s+(.+))?/);
    if (versionMatch) {
      currentVersion = versionMatch[1];
      const date = versionMatch[2];
      versions.set(currentVersion, {
        version: currentVersion,
        date,
        added: [],
        changed: [],
        fixed: [],
        removed: []
      });
      currentSection = null;
      continue;
    }
    
    // Detect section: ### Added, ### Changed, etc.
    const sectionMatch = line.match(/^###\s+(Added|Changed|Fixed|Removed)/i);
    if (sectionMatch && currentVersion) {
      currentSection = sectionMatch[1].toLowerCase() as 'added' | 'changed' | 'fixed' | 'removed';
      continue;
    }
    
    // Add items to the current section
    if (currentVersion && currentSection && line.trim().startsWith('-')) {
      const item = line.trim().substring(1).trim();
      if (item) {
        versions.get(currentVersion)?.[currentSection].push(item);
      }
    }
  }
  
  return versions;
}

export function getChangesForVersion(
  changelogText: string, 
  version: string
): VersionChanges | null {
  const versions = parseChangelog(changelogText);
  return versions.get(version) || null;
}
